import { styled } from '@mui/material/styles';
import { Box } from '@sunwisesoftware/sunwise-ui';

import { scroll } from 'common/utils/mixins';

export default styled(Box)`
    display: flex;
    flex-wrap: nowrap;
    height: calc(100vh - 200px);
    overflow-x: auto;

    .column .drag-funnel-project:last-child {
        margin-bottom: 15px;
    }

    ${scroll.custom()}
`;
